import { LegalPage, LegalSection } from "./LegalLayout";
import { CONTACT, HOST } from "../content";

export default function Terms() {
  return (
    <LegalPage title="Terms & Conditions" updated="JUNE 2026" testid="terms-page">
      <LegalSection heading="1. Acceptance of Terms">
        <p>
          By accessing this website, registering for the webinar, watching the replay, or requesting a review call,
          you agree to these Terms &amp; Conditions and our Privacy Policy. If you do not agree, please do not use
          this website.
        </p>
      </LegalSection>
      <LegalSection heading="2. Educational Purpose — Not a Loan Application">
        <p>
          All content on this website, including the webinar and replay, is provided for educational purposes only.
          Registering, attending, or watching does not constitute a loan application, a loan offer, a commitment to
          lend, or financial, legal, or tax advice. No credit pull is required to attend the webinar or to book a
          review call. Results are not guaranteed; loan approval, rates, and terms depend on underwriting and market
          factors outside our control. Equal Housing Opportunity.
        </p>
      </LegalSection>
      <LegalSection heading="3. SMS / Text Messaging Terms (A2P 10DLC)">
        <p>
          When you opt in to receive text messages from {HOST.name} / {HOST.company}, you agree to the following program
          terms:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>You will receive informational and conversational messages about your registration, replay access, review call scheduling, and related educational content.</li>
          <li><strong className="text-white">Message frequency varies.</strong> Message and data rates may apply depending on your mobile carrier plan.</li>
          <li>Reply <strong className="text-white">STOP</strong> to any message to opt out at any time. After opting out, you will receive one final confirmation message.</li>
          <li>Reply <strong className="text-white">HELP</strong> for assistance, or contact us at {CONTACT.phone} or {CONTACT.email}.</li>
          <li>Consent to receive messages is not a condition of any purchase, loan, or service.</li>
          <li>Carriers are not liable for delayed or undelivered messages.</li>
          <li>No mobile opt-in data or consent will be shared with or sold to third parties or affiliates for marketing purposes.</li>
        </ul>
      </LegalSection>
      <LegalSection heading="4. Licensing">
        <p>
          {HOST.name} is a licensed mortgage professional, NMLS# {HOST.nmls}, operating with {HOST.company}, Company
          NMLS# {HOST.companyNmls}, licensed in {HOST.states}. Nothing on this website is an offer to lend in any state
          where we are not licensed.
        </p>
      </LegalSection>
      <LegalSection heading="5. Intellectual Property">
        <p>
          All website content — text, graphics, logos, video, and design — is owned by or licensed to us and protected
          by applicable intellectual property laws. You may not copy, reproduce, or distribute it without prior
          written permission.
        </p>
      </LegalSection>
      <LegalSection heading="6. Acceptable Use">
        <p>
          You agree not to misuse this website, including attempting to gain unauthorized access, interfering with its
          operation, submitting false information, or using it for any unlawful purpose.
        </p>
      </LegalSection>
      <LegalSection heading="7. Disclaimers & Limitation of Liability">
        <p>
          This website is provided "as is" without warranties of any kind, express or implied. To the fullest extent
          permitted by law, we are not liable for any indirect, incidental, or consequential damages arising from your
          use of this website or reliance on its educational content. Any service guarantee described on this site is
          a guarantee of service effort only — never a guarantee of loan approval, rate, or closing terms.
        </p>
      </LegalSection>
      <LegalSection heading="8. Changes to These Terms">
        <p>
          We may update these Terms from time to time; the "Last Updated" date reflects the latest revision. Continued
          use of the website after changes constitutes acceptance.
        </p>
      </LegalSection>
      <LegalSection heading="9. Contact">
        <p>
          Questions about these Terms? Contact {HOST.name} at {CONTACT.phone} or {CONTACT.email}.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
